import * as remoteAction from "../remoteAction";
import { Product } from "../merchantTypes";
import { getUid } from "../../utils/uuid";

export type PDPPointsTotalActionSuccess = remoteAction.MerchantRemoteResponse<
  "PDP_POINTS_TOTAL_SUCCESS",
  any
>;
export type PDPPointsTotalActionFailure = remoteAction.MerchantRemoteResponse<
  "PDP_POINTS_TOTAL_FAILURE",
  any
>;
export type PDPPointsTotalActionRequest = remoteAction.MerchantRemoteResponse<
  "PDP_POINTS_TOTAL_REQUEST",
  any
>;

export interface PDPPointsTotalAction extends remoteAction.PostRemoteRequest {
  types: {
    request: "PDP_POINTS_TOTAL_REQUEST";
    success: "PDP_POINTS_TOTAL_SUCCESS";
    failure: "PDP_POINTS_TOTAL_FAILURE";
  };
}

export interface GetPDPPointsTotalParams {
  campaignId?: string;
  product: Product;
  amount: number;
  customerId?: string;
  email?: string;
}

export function getPDPPointsTotal({
  amount,
  campaignId,
  product,
  customerId,
  email,
}: GetPDPPointsTotalParams): PDPPointsTotalAction {
  const customer = customerId ? { id: customerId, email } : undefined;

  return {
    method: "POST",
    type: "MERCHANT_REMOTE_REQUEST",
    types: {
      failure: "PDP_POINTS_TOTAL_FAILURE",
      request: "PDP_POINTS_TOTAL_REQUEST",
      success: "PDP_POINTS_TOTAL_SUCCESS",
    },
    data: {
      event: {
        type: "purchase",
        payload: {
          purchase: {
            id: getUid(),
            amount,
            // subtotal is the same as amount in this case as we want to
            // calculate points for the item's value before shipping, taxes,
            // etc.
            subtotal: amount,
            products: [product],
            customer,
          },
        },
      },
      campaignId,
    },
    https: true,
    url: `/rewards/loyalty-reward-preview`,
  };
}
